<template>
  <div class="table-page-search-wrapper">
    <a-form layout="inline">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="设计代表名称">
              <a-input placeholder="请输入设计代表名称" v-model="searchModel.name"/>
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="统一社会信用代码">
              <a-input placeholder="请输入统一社会信用代码" v-model="searchModel.number"/>
            </a-form-item>
          </a-col>
          <template v-if="advanced">
            <a-col :md="8" :sm="24">
              <a-form-item label="状态">
                <a-input placeholder="请输入状态" v-model="searchModel.status"/>
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="8" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
              <a-button type="primary" @click="search">查询</a-button>
              <a-button style="margin-left: 8px" @click="clearSearch">重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px" v-if="true" v-show="showExpend">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" v-if="true" v-show="showExpend"/></a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </a-form>
  </div>
</template>

<script>

export default {
  name: 'DesignSearchForm',
  mounted () {

  },
  data () {
    return {
      showExpend: false,

      searchModel: {},
      advanced: false// 是否展开
    }
  },
  methods: {
    // 搜索框展开
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    // 点击查询按钮
    search () {
      for (const key in this.searchModel) {
        this.searchModel[key] = this.searchModel[key].trim()
      }
      this.$emit('setSearchCondition', this.searchModel)
    },
    // 点击复位按钮
    clearSearch () {
      this.searchModel.id = ''
      this.searchModel.name = ''
      this.searchModel.number = ''
      this.searchModel.status = ''

      this.$emit('clearSearch', this.searchModel)
    }
    // 获取select列表

  }
}
</script>

<style scoped>

</style>
